const SEPA_CHARACTER_REGEX = /^([A-Za-z0-9\ :\/\?\(\)\.,\'+\-&ÄÜÖäüöß])*$/;
const SEPA_CHARACTER_REPLACER_REGEX = /[A-Za-z0-9\ :\/\?\(\)\.,\'+\-&ÄÜÖäüöß]/gi;

//Currently only germany is supported.
const CREDITOR_ID_CHARACTER_REGEX = /DE[0-9]{2}[A-Za-z0-9]{3}0[0-9]{10}$/;

const UMLAUTS_REGEX = /[ÄÜÖäüöß]/gi;

export {
  SEPA_CHARACTER_REGEX,
  UMLAUTS_REGEX,
  SEPA_CHARACTER_REPLACER_REGEX,
  CREDITOR_ID_CHARACTER_REGEX
}
